import React from 'react';
import { connect } from 'dva';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import actions from './actions';
import Button from '../../../Button';
import FeatureListItem from '../../../FeatureListItem';
import Loader from '../../../Loader';
import styles from './ImportedFeatures.module.scss';

export function ImportedFeatures(props) {
  return (
    <>
      <div className={styles.featuresHeader}>
        <h2 className={styles.successTitle}>
          {'Import ' + dayjs().format('MM/DD/YYYY h:mm a')}
        </h2>
        <p className={styles.successCount}>
          {props.importedFeatures.length} items
        </p>
      </div>
      <ul className={styles.featureList}>
        {props.isSavingImport ? (
          <div className={styles.savingLoader}>
            <Loader active={true} />Saving import...
          </div>
          ) : (
          props.importedFeatures.map((feature, i) => {
            return (
              <FeatureListItem
                checkboxDisabled={true}
                feature={{
                  ...feature,
                  properties: {
                    ...feature.properties,
                    ghType: feature.properties.type
                  }
                }}
                key={i}
                showVisibilityIcon={false}
              />
            );
          })
        )}
      </ul>
      {!props.isSavingImport ? (
        <div className={styles.buttonSection}>
          <Button theme={Button.THEME.outlinePrimary} onClick={props.deleteImport}>Cancel</Button>
          <Button theme={Button.THEME.orange} onClick={props.finishImport}>Confirm</Button>
        </div>
      ) : null}
    </>
  );
}

ImportedFeatures.propTypes = {
  isSavingImport: PropTypes.bool,
  importedFeatures: PropTypes.array,
  //actions
  finishImport: PropTypes.func,
  deleteImport: PropTypes.func,
};

export default connect((model) => ({
  importedFeatures: model.dataManager.importedFeatures,
  isSavingImport: model.dataManager.isSavingImport,
}), actions)(ImportedFeatures);
